/**
 * THIS IS AN AUTO-GENERATED FILE FROM SVGR. DO NOT MODIFY!
 *
 * File was made using the 'rushx build:icons' command.
 * To learn more see the {@link https://github.com/seequent/user-portal/blob/master/libraries/web-design-system-2/README.md#making-icons-|ReadMe}
 */
import SvgIcon from '@mui/material/SvgIcon';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { createElement } from 'react';

function SvgCheckIcon(props: SvgIconProps) {
    return createElement(
        SvgIcon,
        { style: { width: '1em', height: '1em' }, viewBox: '0 0 24 24', ...props },
        <path
            fill="currentColor"
            fillOpacity={0.9}
            fillRule="evenodd"
            d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0M7.404 13.97a.5.5 0 0 1 0-.706l.707-.708a.5.5 0 0 1 .707 0l1.06 1.061 5.304-5.303a.5.5 0 0 1 .707 0l.707.707a.5.5 0 0 1 0 .707l-5.657 5.657-.707.707a.5.5 0 0 1-.707 0l-.707-.707z"
            clipRule="evenodd"
        />,
    );
}
export default SvgCheckIcon;
